//@flow
import { styled } from 'linaria/react';
import type { Context } from '../index.h';
type Props = {|
  theme: Context
|};
/**
 * Object root
 */

export const Root =
/*#__PURE__*/
styled("div")({
  name: "Root",
  class: "r1t6taht"
});
/**
 * Table
 */

export const Table =
/*#__PURE__*/
styled("span")({
  name: "Table",
  class: "t1xby0lm"
});
/**
 * HTML
 */

export const HTML =
/*#__PURE__*/
styled("span")({
  name: "HTML",
  class: "h2w76ie"
});
/**
 * Object constructor
 */

export const Constructor =
/*#__PURE__*/
styled("span")({
  name: "Constructor",
  class: "c1gevmxi"
});